import { List, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavItem } from '../styles/navItem';
import { IconImage, IconNestedListItemImage } from '../iconImage';
import {
    ADMIN_ACCOUNT_ROUTE,
    BANNER_ROUTE,
    BRANCH_ROUTE,
    CATEGORY_MERCHANT_ROUTE,
    COUPON_ROUTE, CUSTOMER_ROUTE,
    DELIVERY_FEE_MANAGEMENT_ROUTE,
    DRIVER_BONUS_ROUTE,
    DRIVER_FINANCIAL_CLEARANCE_ROUTE,
    DRIVER_ROUTE,
    HOME_ROUTE,
    MASTER_CATEGORY_ROUTE,
    MASTER_PRODUCT_ROUTE,
    ORDER_ROUTE,
    POPUP_ROUTE,
    PRODUCT_MERCHANT_ROUTE,
    PROMOTION_ROUTE,
    STAFF_ROUTE,
    NOTIFICATION_ROUTE,
    FORM_DRIVER_REGISTER,
    BRAND_ROUTE,
    RIDER_REPORT,
    COUPON_HISTORY,
    RIDER_BALANCE,
    SALES_REPORT_ROUTE,
    CHANGE_MONEY_RIDER,
    HR_MANAGE
} from '../../../routes/paths';
import DASHBOARD_ICON from '../../../assets/images/drawer_icons/dashboard_icon.svg';
import order_ic from '../../../assets/images/dashboard/order_ic.svg';
import customer_ic from '../../../assets/images/dashboard/ic_user.svg';
import admin_ic from '../../../assets/images/dashboard/admin_ic.svg';
import product_ic from '../../../assets/images/drawer_icons/product.svg';
import category_ic from '../../../assets/images/drawer_icons/category_management.svg';
import jiffy_merchant_ic from '../../../assets/images/drawer_icons/jiffy_merchant.svg';
import nested_list_item_ic from '../../../assets/images/drawer_icons/nested_list_item.svg';
import driver_ic from '../../../assets/images/drawer_icons/driver.svg';
import advertisement_ic from '../../../assets/images/drawer_icons/advertisment.svg';
import coupon_ic from '../../../assets/images/drawer_icons/coupon.svg';
import report_ic from '../../../assets/images/dashboard/report_ic.svg'
import { NestedListItem } from '../styles/navListItem';


const SuperAdminNavbar = () => {
    const { t } = useTranslation("global");

    return (
        <List disablePadding sx={{ p: 1, paddingBottom: 10 }}>
            <Typography sx={{ mb: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.GENERAL")}</Typography>
            <NavItem title={t("navbar.Dashboard")} path={HOME_ROUTE} icon={<IconImage imageUrl={DASHBOARD_ICON} />} />
            <NavItem title={t("navbar.Order Management")} path={ORDER_ROUTE} icon={<IconImage imageUrl={order_ic} />} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.REPORT")}</Typography>
            <NavItem title={t("navbar.All Report")} path={SALES_REPORT_ROUTE} icon={<IconImage imageUrl={report_ic} />} />
            <NavItem title={t("navbar.Rider Report")} path={RIDER_REPORT} icon={<IconImage imageUrl={driver_ic} />} />
            <NavItem title={t("navbar.Coupon Report")} path={COUPON_HISTORY} icon={<IconImage imageUrl={coupon_ic} />} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MANAGEMENT")}</Typography>
            <NavItem title={t("navbar.Customer")} path={CUSTOMER_ROUTE} icon={<IconImage imageUrl={customer_ic} />} />
            <NavItem title={t("navbar.HR Manage")} path={HR_MANAGE} icon={<IconImage imageUrl={customer_ic} />} />
            <NavItem title={t("navbar.Admin Account")} path={ADMIN_ACCOUNT_ROUTE} icon={<IconImage imageUrl={admin_ic} />} />
            <NavItem title={t("navbar.Master Product")} path={MASTER_PRODUCT_ROUTE} icon={<IconImage imageUrl={product_ic} />} />
            <NavItem title={t("navbar.Master Category")} path={MASTER_CATEGORY_ROUTE} icon={<IconImage imageUrl={category_ic} />} />
            <NestedListItem nestedValue={t("navbar.Merchant")} iconSrc={jiffy_merchant_ic} listItems={[
                <NavItem key="merchant-user" title={t("navbar.Merchant User")} path={STAFF_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem key="branch" title={t("navbar.Branch")} path={BRANCH_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem key="product-merchant" title={t("navbar.Product Merchant")} path={PRODUCT_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem key="category-merchant" title={t("navbar.Category Merchant")} path={CATEGORY_MERCHANT_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} />
            <NestedListItem nestedValue={t('navbar.Driver')} iconSrc={driver_ic} listItems={[
                <NavItem key="all-driver" title={t("navbar.All Driver")} path={DRIVER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem key="driver-form-register" title={t("navbar.Driver Form Register")} path={FORM_DRIVER_REGISTER} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                // <NavItem title={"Driver bonus"} path={DRIVER_BONUS_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} />

            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.ACCOUNTING")}</Typography>
            <NavItem title={t("navbar.Clearance Money Rider")} path={RIDER_BALANCE} icon={<IconImage imageUrl={driver_ic} />} />
            <NavItem title={t("navbar.Payment Money Rider")} path={DRIVER_FINANCIAL_CLEARANCE_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />


            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.MARKETING")}</Typography>
            <NestedListItem nestedValue={t('navbar.Advertisement')} iconSrc={advertisement_ic} listItems={[
                <NavItem key="pop-up" title={t("navbar.Popup")} path={POPUP_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
                <NavItem key="banner" title={t("navbar.Banner")} path={BANNER_ROUTE} icon={<IconNestedListItemImage imageUrl={nested_list_item_ic} />} />,
            ]} />
            <NavItem title={t("navbar.Promotion")} path={PROMOTION_ROUTE} icon={<IconImage imageUrl={jiffy_merchant_ic} />} />
            <NavItem title={t("navbar.Coupon Management")} path={COUPON_ROUTE} icon={<IconImage imageUrl={coupon_ic} />} />
            <NavItem title={t("navbar.Notification")} path={NOTIFICATION_ROUTE} icon={<IconImage imageUrl={advertisement_ic} />} />


            <Typography sx={{ mb: 2, mt: 2, pl: 1, fontWeight: 'bold', color: "#637381" }}>{t("navbar.SETTING")}</Typography>
            <NavItem title={t("navbar.Multiplier Money")} path={CHANGE_MONEY_RIDER} icon={<IconImage imageUrl={order_ic} />} />
            <NavItem title={t("navbar.Delivery Free management")} path={DELIVERY_FEE_MANAGEMENT_ROUTE} icon={<IconImage imageUrl={driver_ic} />} />
        </List>
    );
};

export default SuperAdminNavbar;